/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CreateOfferMutationVariables = Types.Exact<{
	input: Types.CreateOfferRequest;
}>;

export type CreateOfferMutation = {
	__typename?: "Mutation";
	createOffer: {
		__typename?: "CreateOfferResponse";
		offer?: {
			__typename?: "Offer";
			offerId: string;
			type: Types.TradeType;
			isFeeTransparent: boolean;
			isTaxable: boolean;
			userJourney: string;
			price: { __typename?: "CurrencyAmount"; value: string };
			amountFiat: { __typename?: "CurrencyAmount"; value: string };
			amountAsset: { __typename?: "CurrencyAmount"; value: string };
			currentBorrow?: { __typename?: "CurrencyAmount"; value: string } | null;
			futureBorrow?: { __typename?: "CurrencyAmount"; value: string } | null;
			effectiveLeverage?: { __typename?: "CurrencyAmount"; value: string } | null;
			fee?: {
				__typename?: "Fee";
				fiat: { __typename?: "FeeAmount"; value: string };
				asset: { __typename?: "FeeAmount"; value: string };
				net: { __typename?: "FeeAmount"; value: string };
				percentage: { __typename?: "FeePercentage"; value: string };
				priceWithoutFee: { __typename?: "FeeAmount"; value: string };
			} | null;
			tax?: {
				__typename?: "Tax";
				isTaxServiceAvailable: boolean;
				fiatId: string;
				assetId?: string | null;
				taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
				fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
				taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
			} | null;
			vsnFeeTokenCollection?: {
				__typename?: "VsnFeeTokenCollection";
				globalOptIn?: boolean | null;
				enabled: boolean;
				eligibleForVsn: boolean;
				feeDiscount: string;
				visionFeeDetail?: {
					__typename?: "VisionFeeDetail";
					visionRate: string;
					visionAmount: string;
					feeBefore: string;
					hasEnoughFunds: boolean;
					bonus: { __typename?: "Bonus"; amount: string; unitId: string; type: Types.BonusType };
				} | null;
			} | null;
			expiresAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			warnings: Array<{ __typename?: "OfferWarning"; link: string; link_message: string; message: string }>;
		} | null;
	};
};

export const CreateOfferDocument = gql`
	mutation createOffer($input: CreateOfferRequest!) {
		createOffer(request: $input) {
			offer {
				offerId
				price {
					value
				}
				amountFiat {
					value
				}
				amountAsset {
					value
				}
				currentBorrow {
					value
				}
				futureBorrow {
					value
				}
				effectiveLeverage {
					value
				}
				type
				fee {
					fiat {
						value
					}
					asset {
						value
					}
					net {
						value
					}
					percentage {
						value
					}
					priceWithoutFee {
						value
					}
				}
				isFeeTransparent
				tax {
					taxAmountFiat {
						value
					}
					isTaxServiceAvailable
					fiatId
					assetId
					fiatAmountAfterTax {
						value
					}
					taxAmountAsset {
						value
					}
				}
				isTaxable
				userJourney
				vsnFeeTokenCollection {
					globalOptIn
					enabled
					eligibleForVsn
					feeDiscount
					visionFeeDetail {
						visionRate
						visionAmount
						feeBefore
						hasEnoughFunds
						bonus {
							amount
							unitId
							type
						}
					}
				}
				expiresAt {
					iso8601
					unixTimestamp
				}
				serverTime {
					iso8601
					unixTimestamp
				}
				warnings {
					link
					link_message
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CreateOfferGQLService extends Apollo.Mutation<CreateOfferMutation, CreateOfferMutationVariables> {
	document = CreateOfferDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
